/* global Pusher */
// Pusher.logToConsole = true;

var pusher = new Pusher($('body').attr('data-pusher'), {
	encrypted: true,
	cluster: $('body').attr('data-pusher_cluster')
});

var channel = pusher.subscribe($('body').attr('data-channel'));